/* eslint-disable max-classes-per-file */

export interface RequestTravelStoryRecommendInterface {
  // define the parameters required for the request
  homePage?: number;
  klubCategory?: string;
  page?: number; // if send page must include limit value
  limit?: number; // if not send or limit = 0 default get total all
}

export class ResponseTravelStoryRecommendInterface {
  slug: string;

  storyId: number;

  title: string;

  location: string;

  isGreenCertificate?: boolean;

  locationSlug: string;

  thumbImage: {
    image11: string;
    image43: string;
  };

  klubCategory?: string;

  constructor(data: any) {
    this.slug = data.slug || "";
    this.storyId = data.storyId || 0;
    this.title = data.title || "";
    this.location = data.location || "";
    this.locationSlug = data.locationSlug || "";
    this.thumbImage = {
      image11: data.thumbImage?.image_1x1 || "",
      image43: data.thumbImage?.image_4x3 || "",
    };
    this.klubCategory = data.klubCategory || "";
    this.isGreenCertificate = data?.isGreenCertificate || false;
  }
}
